// extracted by mini-css-extract-plugin
export var actions = "_gf-d";
export var benefitCard = "_gf-a";
export var benefitIcon = "_gf-b";
export var benefitLabel = "_gf-c";
export var benefits = "_gf-9";
export var bodyText = "_gf-8";
export var closeButton = "_gf-2";
export var content = "_gf-3";
export var eyebrow = "_gf-4";
export var heading = "_gf-5";
export var image = "_gf-f";
export var imagePanel = "_gf-e";
export var modal = "_gf-0";
export var shell = "_gf-1";
export var title = "_gf-6";
export var titleOffer = "_gf-7";